import { LitElement, html } from '@hh/global.js'

class ProductIndigloToggle2025 extends LitElement {
  static properties = {
    checked: {
      type: Boolean,
      reflect: true,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    this.button = this.querySelector('button')
    this.button.addEventListener('click', this.handleButton.bind(this))
    this.wrapper = this.closest('[product-details]')
    super.connectedCallback()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  handleButton() {
    this.checked = !this.checked

    if (this.checked) {
      this.wrapper.classList.add('show-indiglo')
      this.button.setAttribute('aria-checked',true)
    } else {
      this.wrapper.classList.remove('show-indiglo')
      this.button.setAttribute('aria-checked',false)
    }
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('indiglo-toggle-2025', ProductIndigloToggle2025)
